import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
// import { LeadsService } from '../../../services/leads-service/leads-service.service';
import {
	NgbDate,
	NgbCalendar,
	NgbDateParserFormatter,
	NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { TemplatesService } from '../../services/templates/templates.service';
import { User } from '../../core/models/user';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas';
import * as dayjs from 'dayjs';
import { Date_range } from '../../core/models/date-range';
import { FormGroup, FormControl } from '@angular/forms';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LeadService } from 'src/app/services/lead/lead.service';

@Component({
	selector: 'app-chargeback',
	templateUrl: './chargeback.component.html',
	styleUrls: ['./chargeback.component.scss'],
})
export class ChargebackComponent implements OnInit {
	loading = false;
	idLead = 0;
	user: User = null;
	dateRange: Date_range = {
		dateStart: dayjs().subtract(10, 'days'),
		dateEnd: dayjs(new Date()),
	};

	//Table
	columnMode = ColumnMode;
	rowsPayeds = [];
	SearchPaid = [];

	dataSearch = new FormGroup({
		numLeadP: new FormControl(''),
		agentP: new FormControl(''),
		aliasP: new FormControl(''),
		prospectP: new FormControl(''),
		campaignP: new FormControl(''),
		AmountP: new FormControl(''),
		dateRangeP: new FormControl(this.dateRange),
	});

	@ViewChild('tablePaid') tablePaid: DatatableComponent;

	constructor(
		// private leadsService: LeadsService,
		public authenticationService: AuthenticationService,
		private calendar: NgbCalendar,
		public formatter: NgbDateParserFormatter,
		public utilService: UtilsService,
		private templatesService: TemplatesService,
		private router: Router,
		private dataService: OldDataService,
		private leadSrv: LeadService
	) {
		// this.fromDate = calendar.getPrev(calendar.getToday(), "d", 10);
		// this.toDate = calendar.getToday();
		this.refreshLeads();
	}

	ngOnInit(): void {}

	refreshLeads() {
		this.getPayedLeads();
	}

	searchInformation(dateRangeSelected) {
		this.getPayedLeads();
	}

	getPayedLeads() {
		this.loading = true;

		let numlead: number;
		let agent: string;
		let alias: string;
		let prospect: string;
		let campaignName: string;
		let amount: number;

		let select_daterange = this.dataSearch.controls['dateRangeP'].value;

		let from_date =
			select_daterange.dateStart.format('YYYY-MM-DD') + ' 00:00:00';
		let to_date =
			select_daterange.dateEnd.format('YYYY-MM-DD') + ' 23:59:59';

		if (
			this.dataSearch.controls['numLeadP'].value != undefined ||
			this.dataSearch.controls['numLeadP'].value != ''
		) {
			numlead = this.dataSearch.controls['numLeadP'].value;
		}
		if (
			this.dataSearch.controls['agentP'].value != undefined ||
			this.dataSearch.controls['agentP'].value != ''
		) {
			agent = this.dataSearch.controls['agentP'].value;
		}
		if (
			this.dataSearch.controls['aliasP'].value != undefined ||
			this.dataSearch.controls['aliasP'].value != ''
		) {
			alias = this.dataSearch.controls['aliasP'].value;
		}
		if (
			this.dataSearch.controls['prospectP'].value != undefined ||
			this.dataSearch.controls['prospectP'].value != ''
		) {
			prospect = this.dataSearch.controls['prospectP'].value;
		}
		if (
			this.dataSearch.controls['campaignP'].value != undefined ||
			this.dataSearch.controls['campaignP'].value != ''
		) {
			campaignName = this.dataSearch.controls['campaignP'].value;
		}
		if (
			this.dataSearch.controls['AmountP'].value != undefined ||
			this.dataSearch.controls['AmountP'].value != ''
		) {
			amount = this.dataSearch.controls['AmountP'].value;
		}

		// , this.agentP.nativeElement.value, this.aliasP.nativeElement.value, this.prospectP.nativeElement.value, this.campaignP.nativeElement.value, this.AmountP.nativeElement.value

		this.leadsBilled(
			from_date,
			to_date,
			numlead,
			agent,
			alias,
			prospect,
			campaignName,
			amount,
		);
	}

	updateFilterP(event, opcion) {
		const val = event.target.value.toLowerCase();
		let answer_filter: any[];
		let searchWithFilters: any[];

		if (val != '') {
			searchWithFilters = this.rowsPayeds;
		} else {
			searchWithFilters = this.SearchPaid;
		}

		switch (opcion) {
			case 1: //id
				answer_filter = searchWithFilters.filter(function (d) {
					return d.id.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 2: //generated_by
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.generated_by.toLowerCase().indexOf(val) !== -1 || !val
					);
				});

				break;
			case 3: //alias
				answer_filter = searchWithFilters.filter(function (d) {
					return d.alias.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 4: //prospect_company
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.prospect_company.toLowerCase().indexOf(val) !== -1 ||
						!val
					);
				});

				break;
			case 5: //campaign_name
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.campaign_name.toLowerCase().indexOf(val) !== -1 ||
						!val
					);
				});

				break;
			case 6: //campaign_name
				answer_filter = searchWithFilters.filter(function (d) {
					return d.amount.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			default:
				break;
		}

		this.rowsPayeds = answer_filter;
		this.tablePaid.offset = 0;
	}

	datePickerToPHP(date) {
		let mes = '';
		let dia = '';

		if (date.month < 10) {
			mes = '0' + date.month;
		} else {
			mes = date.month;
		}

		if (date.day < 10) {
			dia = '0' + date.day;
		} else {
			dia = date.day;
		}
		return date.year + '-' + mes + '-' + dia;
	}
	validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
		const parsed = this.formatter.parse(input);
		return parsed && this.calendar.isValid(NgbDate.from(parsed))
			? NgbDate.from(parsed)
			: currentValue;
	}
	cleanFiltersSearchP() {
		this.dataSearch.reset();

		this.dataSearch = new FormGroup({
			numLeadP: new FormControl(''),
			agentP: new FormControl(''),
			aliasP: new FormControl(''),
			prospectP: new FormControl(''),
			campaignP: new FormControl(''),
			AmountP: new FormControl(''),
			dateRangeP: new FormControl(this.dateRange),
		});

		this.getPayedLeads();
	}
	summaryFor(opcion: number) {
		var totalCostPayed: number;
		var listNumber: number[];
		totalCostPayed = 0;

		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0,
		});

		switch (opcion) {
			case 2: {
				listNumber = this.rowsPayeds.map((row) => row['amount']);
				listNumber = listNumber.map(Number);
				totalCostPayed = listNumber.reduce(
					(res, cell) => (res += cell),
					0,
				);
				return formatter.format(totalCostPayed);
			}
		}
	}
	getContentIcon({ row, column, value }): any {
		return {
			' content-icon': row['id'] > 0,
		};
	}
	downloadTemplate(row) {
		this.idLead = row.id;
		var div;
		const options = {
			background: 'white',
			scale: 1,
		};

		this.loading = true;

		setTimeout(() => {
			div = document.getElementById('details');
			html2canvas(div, options).then((canvas) => {
				let cont_image = document.createElement('div');
				cont_image.id = 'cont_img';
				let image = document.createElement('img');
				image.src = canvas.toDataURL();
				image.id = 'lead_print';
				image.height = 500;
				image.width = 600;
				cont_image.appendChild(image);

				const leadHtml = cont_image.innerHTML;

				this.templatesService
					.layaout_format_bank(row.id, leadHtml, '')
					.then((data) => {
						if (!data.hasOwnProperty('error')) {
							this.utilService.exportWord(
								data,
								'Dispute Package - ' +
									row.campaign_name +
									' - ' +
									row.first_name +
									' ' +
									row.last_name,
							);
							this.idLead = 0;
							this.loading = false;
						} else {
							this.idLead = 0;
							this.loading = false;
						}
					});
			});
		}, 2000);
	}

	leadsBilled(
		fromDate: any,
		toDate: any,
		idLead: number,
		agent: string,
		alias: string,
		prospect: string,
		campaignName: string,
		amount: any,
	) {

		const payload = {
			from_date: fromDate,
			to_date: toDate,
			order_by: 'lead_creation',
			asc_desc: 'ASC',
			id_lead: idLead,
			agent: agent,
			alias: alias,
			prospect: prospect,
			campaign_name: campaignName,
			amount: amount,
		}

		this.leadSrv.getAllPayedChargeBacks(payload).subscribe((data:any)=>{
			this.rowsPayeds = data.body;
			this.SearchPaid = this.rowsPayeds;
			this.loading = false;
		})
	}
}
